import { DropzoneFullScreen } from './DropzoneFullScreen.js';
import { Dropzone as Dropzone$1 } from './Dropzone.js';
export { EXE_MIME_TYPE, IMAGE_MIME_TYPE, MIME_TYPES, MS_EXCEL_MIME_TYPE, MS_POWERPOINT_MIME_TYPE, MS_WORD_MIME_TYPE, PDF_MIME_TYPE } from './mime-types.js';

Dropzone$1.FullScreen = DropzoneFullScreen;
const Dropzone = Dropzone$1;

export { Dropzone };
//# sourceMappingURL=index.js.map
